module.exports = __webpack_public_path__ + "img/electric_pending_zone_selected.07f4de56.svg";